import { render } from "./SupplierReturnShowView.vue?vue&type=template&id=4701a8c0&scoped=true"
import script from "./SupplierReturnShowView.vue?vue&type=script&lang=js"
export * from "./SupplierReturnShowView.vue?vue&type=script&lang=js"

import "./SupplierReturnShowView.vue?vue&type=style&index=0&id=4701a8c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4701a8c0"]])

export default __exports__